/* Publish by EComposer at 2026-11-03 05:34:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6fupgcepgdg"]=  window.__ectimmers["ecom-6fupgcepgdg"] || {};
const $el = this.$el;
                console.log('javaaaaaaafasfasfdasf', this)
                if (!$el) return;
                const products_item = $el.querySelectorAll('.ecom-product-upsell__item');
                const no_item = $el.querySelector('.ecom-product-upsell-no-item');
                const heading = $el.querySelector('.ecom-products-upsell-design-2');
                if (no_item && heading)
                    heading.style.display = 'none';



                // ==========

                if (this.settings?.layout_type == 'horizontal' && this.settings?.design == 'design_2') {
                    const $container = $el.querySelector('.ecom-swiper');
                    let optionSwiper = $container && $container.dataset.optionSwiper;
                    optionSwiper = JSON.parse(optionSwiper);
                    optionSwiper.navigation = {
                        nextEl: $el.querySelector(".ecom-product-upsell__next"),
                        prevEl: $el.querySelector(".ecom-product-upsell__prev")
                    };
                    optionSwiper.slidesPerView = 1;
                    optionSwiper.loop = false;
                    optionSwiper.breakpoints = {
                        768: {
                            slidesPerView: 'auto'
                        }
                    };
                    let ecomSlider = new window.EComSwiper($container, optionSwiper);
                    function ecomSliderInit () {
                        ecomSlider.init(); // Gọi phương thức init() để khởi tạo swiper
                    }
                    if (window.EComSwiper) {
                        ecomSliderInit();
                    }
                }


                // ==========

                if (products_item.length == 0) {
                    return;
                }

                const handleVariantSelect = () => {

                    if (products_item) {
                        products_item.forEach((item, index) => {
                            let select_id = item.querySelector('select[name=ecom-product-upsell-select]'),
                                item_image = item.querySelector('.ecom-product-upsell__image'),
                                item_btn_atc = item.querySelector('.ecom-product-upsell__item--atc-btn');

                            let item_btn_atc_text = null, atc_text = null, unavailable_text = null;
                            if (item_btn_atc) {
                                item_btn_atc_text = item_btn_atc.querySelector('span.ecom-product-upsell__item--atc-btn-text');
                                atc_text = item_btn_atc.dataset.atcText;
                                unavailable_text = item_btn_atc.dataset.unavailableText;
                            }

                            if (!select_id) return;
                            select_id.addEventListener('change', (e) => {
                                let selected_index = select_id.options[select_id.selectedIndex];

                                if (!selected_index) return;

                                let price = selected_index.getAttribute('data-price'),
                                    compare_at_price = selected_index.getAttribute('data-compare-price') || 0,
                                    image = selected_index.getAttribute('data-image'),
                                    available = selected_index.getAttribute('data-available'),
                                    product_id = selected_index.value;

                                item.querySelector('input[name=product_id]').value = product_id;
                                updatePrice(price, compare_at_price, item);

                                if (item_btn_atc_text) {
                                    if (available == 'false') {
                                        item_btn_atc.setAttribute('disabled', 'disabled');
                                        if (unavailable_text && item_btn_atc_text) {
                                            item_btn_atc_text.innerText = unavailable_text
                                        }
                                    } else {
                                        item_btn_atc.removeAttribute('disabled');
                                        if (atc_text && item_btn_atc_text) {
                                            item_btn_atc_text.innerText = atc_text
                                        }
                                    }
                                }

                                item_image.classList.add('ecom-loading-image');
                                item_image.querySelector('img').setAttribute('src', image);
                                item_image.querySelector('img').onload = () => {
                                    item_image.classList.remove('ecom-loading-image');
                                }

                            })

                        });
                    }

                    function updatePrice (price, compare_at_price, el) {
                        const $price_regular = el.querySelector(
                            '.ecom-product-upsell__price--regular'
                        );
                        const $price = el.querySelector('.ecom-product-upsell__price--sale');

                        if ($price) {
                            $price.innerHTML = window.EComposer.formatMoney(price);
                        }

                        if ($price_regular) {
                            $price_regular.innerHTML = window.EComposer.formatMoney(
                                compare_at_price
                            );
                            if (compare_at_price > price) {
                                $price_regular.style.display = 'inherit';
                            } else {
                                $price_regular.style.display = 'none';
                            }
                        }
                    }
                }

                const handleATC = () => {
                    const $btn_atc = $el.querySelectorAll('.ecom-product-upsell__item--atc-btn');

                    if ($btn_atc) {
                        $btn_atc.forEach(function (btn) {
                            let item_btn_atc_text = btn.querySelector('span.ecom-product-upsell__item--atc-btn-text'),
                                added_text = btn.dataset.addedText,
                                action = btn.dataset.action,
                                target = btn.dataset.target,
                                href = btn.dataset.href;

                            btn.addEventListener('click', (e) => {
                                e.preventDefault();
                                const _this = e.target;
                                btn.classList.add('ecom-loading');
                                let product_id = null
                                try {
                                    product_id = btn.closest('.ecom-product-upsell__item').querySelector('input[name=product_id]').value;
                                } catch (error) {
                                    console.log(error);
                                }
                                if (!product_id) return;

                                let quantity = btn.closest('.ecom-product-upsell__item').querySelector('input[name=quantity-upsell]') ? btn.closest('.ecom-product-upsell__item').querySelector('input[name=quantity-upsell]').value : 1;

                                let item = {
                                    'id': product_id,
                                    'quantity': quantity || 1
                                };
                                fetch('/cart/add.js?sections=cart-notification-product,cart-notification-button,cart-icon-bubble,cart-drawer', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(item)
                                })
                                    .then(response => {
                                        return response.json();
                                    })
                                    .then(response => {
                                        if (window.EComposer.ajaxCartSuccess)
                                            // window.EComposer.ajaxCartSuccess(response);
                                            switch (action) {
                                                case "popup":
                                                    window.EComposer.ajaxCartSuccess(response);
                                                    break;
                                                case "cart":
                                                    return (window.location.href =
                                                        window.EComposer.routes.cart_url);
                                                case "reload":
                                                    return window.location.reload();
                                                case "checkout":
                                                    return (window.location.href =
                                                        window.EComposer.routes.root_url +
                                                        (window.EComposer.routes.root_url === "/" ? "" : "/") +
                                                        "checkout");
                                                case "message":
                                                    if (response.message)
                                                        window.EComposer.showToast(response.message + ' - ' + response?.description);
                                                    else if (added_text != '') {
                                                        window.EComposer.showToast(added_text);
                                                    }
                                                    break;
                                                case "link":
                                                    if (href && href != '') {
                                                        if (target === "_blank") {
                                                            return window.open(href);
                                                        } else {
                                                            return (window.location.href = href);
                                                        }
                                                    }
                                                default:
                                                    window.EComposer.ajaxCartSuccess(response);
                                                    break;
                                            }
                                        btn.classList.remove('ecom-loading');
                                        document.dispatchEvent(new CustomEvent('ec-cart-added', { detail: response }))
                                        if (!response.message && added_text) {
                                            item_btn_atc_text.innerText = added_text;
                                        }

                                    })
                                    .catch((error) => {
                                        console.error('Error:', error);
                                    });
                            })
                        })
                    }
                }

                const handleAnimation = function (_this) {
                    if (!$el) return;

                    const $btn_wrapper = $el.querySelectorAll('.ecom-product-upsell__item--atc-btn');
                    if (!$btn_wrapper) return;

                    $btn_wrapper.forEach(function (btn) {
                        let intervalTime = parseInt(_this.settings.animation_loop_time) * 1000 || 6000,
                            animTime = 1000;window.__ectimmers["ecom-6fupgcepgdg"]["eufki86zj"] = setInterval(function () {
                            btn.classList.add('animated');
                            setTimeout(function () {
                                btn.classList.remove('animated');
                            }, animTime);
                        }, intervalTime);
                    })

                }

                if (this.settings.animation) {
                    handleAnimation(this);
                }

                handleVariantSelect();
                if (!window.ECOM_LIVE)
                    handleATC();

                function handleQuantityInput () {
                    const items = $el.querySelectorAll('.ecom-product-upsell__item');
                    items.forEach(function (item) {
                        const quantityInput = item.querySelector('.ecom-product-upsell__item--quantity-input');
                        const minusButton = item.querySelector('.ecom-product-upsell__item--quantity-button-minus');
                        const plusButton = item.querySelector('.ecom-product-upsell__item--quantity-button-plus');
                        if (!quantityInput) return;

                        quantityInput.addEventListener('change', function (e) {
                            const value = e.target.value;
                            if (minusButton) {
                                minusButton.disabled = value < 1;
                            }

                            let tagA = item.querySelector('a.ecom-collection__product-submit');
                            if (e.target.value > parseInt(e.target.max)) {
                                e.target.value = parseInt(e.target.max);
                            }
                            if (tagA) {
                                let link = tagA.getAttribute('href');
                                tagA.setAttribute('href', link.replace(/quantity=(\d*)/gm, `quantity=${e.target.value}`));
                            }
                        });

                        if (!minusButton || !plusButton) return;

                        minusButton.addEventListener('click', function (e) {
                            e.preventDefault();
                            const value = quantityInput.value;
                            if (value > 1) {
                                quantityInput.value = parseInt(value) - 1;
                            }
                        });

                        plusButton.addEventListener('click', function (e) {
                            e.preventDefault();
                            const value = quantityInput.value;
                            quantityInput.value = parseInt(value) + 1;
                        });
                    });
                }

                handleQuantityInput();

                    });
                    
                        document.querySelectorAll('.ecom-6fupgcepgdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6fupgcepgdg', settings: {"layout_type":"vertical","animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}